<sd-searchbox-search-bar
  [searchInputControl]="searchInputControl"
  [isLoading]="isLoading$ | async"
  [isEmpty]="isEmpty$ | async"
  [results]="results$ | async"
  [query]="query$ | async"
  (clear)="clear()"
  [maxLength]="config.searchPhraseMaxLength"
  (onFocusSearchInput)="onFocusSearchInput()"
  (onEnterSearchInput)="onEnterSearchInput()"
  (onClickTapItem)="onClickTapItem($event)"
  (searchHistoryReset)="searchHistoryService.reset()"
  (searchHistoryRemove)="searchHistoryService.remove($event)"
  (onClickHistoryItem)="onClickHistoryItem($event)"
  (onClickStsItem)="onClickStsItem($event)"
  (onClickCategoryItem)="onClickCategoryItem($event)"
  (onClickBrandItem)="onClickBrandItem($event)"
></sd-searchbox-search-bar>
